import {BaseDomainModel} from "../../../infrastructure/models/base-domain-model";
import {RankingsApiModel} from "./rankings.api-model";

export class RankingsDomainModel extends BaseDomainModel {
  apiModel: RankingsApiModel;

  get name(): String {
    return this.apiModel.name;
  }

  get shortName(): String {
    return this.apiModel.shortName;
  }

  get position(): Number {
    return this.apiModel.position;
  }
}